export const headers = {
  'X-API-VERSION': 'v1',
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
